import { useNavigate } from "react-router-dom";
import { EmptyBusinessSkeleton } from "../EmptyBusinessSkeleton";
import EmptyState from "../EmptyState";

const EmptyBusiness = ({ loading }) => {
  const navigate = useNavigate();

  return loading ? (
    <EmptyBusinessSkeleton />
  ) : (
    <EmptyState
      titleKey="No Business Profile Yet"
      descriptionKey="Please create a business profile first."
      buttonTitle="Create Business Profile"
      onClick={() =>
        navigate("/business/create", { state: { onboarding: true } })
      }
    />
  );
};

export default EmptyBusiness;
